import { useSyncExternalStore } from 'react';

import { useFetchCacheStore } from '../../store/FetchCache';
import { useIntegrationsStore } from '../../store/Inbox/Integrations';

const subscribeToHydration = (onChange: () => void) =>
  useIntegrationsStore.persist.onFinishHydration(onChange);

const getIsHydrated = () => useIntegrationsStore.persist.hasHydrated();

export const useAreIntegrationsReady = (): boolean => {
  const isHydrated = useSyncExternalStore(
    subscribeToHydration,
    getIsHydrated,
    getIsHydrated,
  );
  const isFetched = useFetchCacheStore((s) => s.loadedIntegrations);

  return isHydrated && isFetched;
};
